import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { CheckpointGroup } from '@/api/entities/checkpointGroup';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

export const createCheckpointGroup = async (data: CheckpointGroup) => {
  return requestApi({
    url: '/checkpointGroup/create',
    method: HTTP_METHOD.POST,
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const findByGroupId = async (groupId: string) => {
  return requestApi({
    url: `/checkpointGroup/group/${groupId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateCheckpointGroup = async (data: CheckpointGroup) => {
  return requestApi({
    url: '/checkpointGroup/update',
    method: HTTP_METHOD.PUT,
    body: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const findEquipmentsByCheckpointGroup = async (
  groupId: string,
  checkpointId
) => {
  return requestApi({
    url: `/checkpointGroup/equipment/${groupId}/${checkpointId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};
